import React from "react";
import { Alert, Box, CircularProgress, Typography } from "@mui/material";
import { TEXT } from "../../dark-theme/palette";

export default function TutorsWorkspaceShell({ title, children, loading, error, maxWidth = 880, leading = null }) {
    return (
        <Box sx={{ maxWidth, mx: "auto", px: { xs: 2, sm: 3 }, py: { xs: 3, sm: 5 } }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                {leading}
                <Typography variant="h4" sx={{ fontWeight: 800, color: TEXT.primary, minWidth: 0 }}>
                    {title}
                </Typography>
            </Box>
            {error ? (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                </Alert>
            ) : null}
            {loading ? (
                <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
                    <CircularProgress />
                </Box>
            ) : (
                children
            )}
        </Box>
    );
}
